import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import LoginForm, { IStateProps, IDispatchProps, IOwnProps } from './LoginForm'
import { IStoreState } from '../../services/store/IStoreState'
import { AuthAction, requestLogin } from '../../services/store/actions/auth/AuthAction'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    isRequesting: state.Auth.isRequesting,
    error:        state.Auth.error,
  }
}

function mapDispatchToProps(dispatch: Dispatch<AuthAction>): IDispatchProps {
  return {
    requestLogin: (email, password) => dispatch(requestLogin(email, password)),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm)
